import React, { useCallback } from 'react';
import { Button, Radio, Breadcrumb, Checkbox, Divider, Spin } from '../index';
const MulitlevelPicker = ({ title, dataKey, displayKey, childrenKey, dataSource, initialValue, value = [], showSelectAll = true, multiple = false, loadData, onLevelChange, dataSimpleMode, prefixCls = 'oss-ui', }) => {
    const onValueChange = useCallback(() => { }, []);
    const onClickNextLevet = useCallback(() => { }, []);
    return (<div className={`${prefixCls}-mulitlevel-picker-wrapper`}>
            <div className="mulitlevel-picker-source-wrapper">
                <h3 className="multilevel-picker-source-header">{title}</h3>
                <div className="multilevel-picker-source-breadcrumb">
                    <Breadcrumb>
                        {/* {topLevelList.map((item, index) => {
            return (
                <Breadcrumb.Item key={String(item[dataKey])}>
                    <Button
                        type="link"
                        disabled={index === topLevelList.length - 1}
                        onClick={() => {
                            topLevelListClick(index);
                        }}
                    >
                        {item[displayKey]}
                    </Button>
                </Breadcrumb.Item>
            );
        })} */}
                    </Breadcrumb>
                </div>
                <Spin spinning={false}>
                    <div className="multilevel-picker-source-content">
                        {/* 显示全选 */}
                        {showSelectAll && (<div className="multilevel-picker-check-all">
                                {multiple && (<Checkbox>
                                        {/* {locales.get('components-common-select-users-v8t68084fqr')} */}
                                        全选
                                    </Checkbox>)}
                            </div>)}

                        {dataSource &&
            dataSource.map((item) => {
                return (<div key={`${item[dataKey]}`} className="multilevel-picker-source-node">
                                        {multiple ? (<Checkbox value={item} checked={value.some((itemSelectedValue) => itemSelectedValue[dataKey] === item[dataKey])} onChange={onValueChange}>
                                                {item[displayKey]}
                                            </Checkbox>) : (<Radio value={item} checked={value.some((itemSelectedValue) => itemSelectedValue[dataKey] === item[dataKey])} onChange={onValueChange}>
                                                {item[displayKey]}
                                            </Radio>)}
                                        {item['showLevel'] && (<div className="check-box-btn">
                                                <Divider type="vertical"/>
                                                <Button type="link" onClick={onClickNextLevet.bind(item)}>
                                                    {/* <Icon type="xiaji"></Icon> */}
                                                    下级
                                                    {/* {locales.get('components-common-select-users-id0f29c3yj')} */}
                                                </Button>
                                            </div>)}
                                    </div>);
            })}
                    </div>
                </Spin>
            </div>
        </div>);
};
export default MulitlevelPicker;
